const ru_RU = {
  "colorpicker.opacity-input": "Непрозрачность",
  "datepicker.clear-date": "Очистить дату",
  "datepicker.next-month": "Следующий месяц",
  "datepicker.open-calendar": "Открыть календарь",
  "datepicker.previous-month": "Предыдущий месяц",
  "input.clear": "Очистить поле ввода",
  "input.hide-password": "Скрыть пароль",
  "input.show-password": "Показать пароль",
  "modal.close": "Закрыть",
  "multiselectchips.add-value": "Добавить «{value}»",
  "multiselectchips.remove-all": "Удалить всё",
  "pagination.next-page": "Следующая страница",
  "pagination.previous-page": "Предыдущая страница"
};
export {
  ru_RU as default
};
//# sourceMappingURL=ru_RU.json.js.map
